import { ScrollSpyComponent } from './components/scrolls/scroll-spy.component';
import { NgModule} from '@angular/core';

@NgModule ({

    declarations: [
        ScrollSpyComponent        
    ],
    exports: [
        ScrollSpyComponent
    ]

})

export class ScrollSpyModule { }